import React from 'react';
import PropTypes from 'prop-types';
import IconButton from '@material-ui/core/IconButton';
import MoreIcon from '@material-ui/icons/MoreVert';

function MobileNav(props) {
  const {
    classes,
    handleMobileMenuOpen,
  } = props;
  return (
    <div className={classes.sectionMobile}>
      <IconButton aria-haspopup="true" onClick={handleMobileMenuOpen} color="inherit">
        <MoreIcon />
      </IconButton>
    </div>
  );
}

MobileNav.propTypes = {
  classes: PropTypes.object.isRequired,
  handleMobileMenuOpen: PropTypes.func.isRequired,
};

export default MobileNav;
